import React from 'react';
import { AppButton, Box, Inscription, Preloader, WarningIcon } from '@common-fe/common-fe';

import ModalWrapper from '@/components/wrappers/ModalWrapper';

interface Props {
  isLoading?: boolean;
  onSetVisible: (value: boolean) => void;
  onSubmit: () => void;
}

const RemoveCredentialsConfirmModal: React.FC<Props> = ({ isLoading, onSetVisible, onSubmit }) => (
  <ModalWrapper testId="remove-credentials" visible onSetVisible={onSetVisible}>
    <Box align="center">
      <WarningIcon size="48px" />

      <Inscription data-testId="remove-credentials-modal_title" margin={{ top: 'spacing12' }} size="2xl" weight={700}>
        Remove Credentials?
      </Inscription>

      <Inscription data-testId="remove-credentials-modal_subtitle" textAlign="center" margin={{ top: 'spacing12' }}>
        Once credentials have been removed any active sessions will be immediately logged out
        and the user will need to go through new user registration to create a new username and password.
      </Inscription>

      <Box margin={{ top: 'spacing24' }} direction="row" width="100%" justify="center">
        <Box width={{ max: '200px', width: '100%' }}>
          <AppButton
            testId="remove-credentials-modal_close"
            onClick={() => onSetVisible(false)}
            width="100%"
            buttonType="secondary"
          >
            Close
          </AppButton>
        </Box>
        <Box width={{ max: '200px', width: '100%' }} margin={{ left: 'spacing12' }}>
          <AppButton
            testId="remove-credentials-modal_remove"
            onClick={onSubmit}
            width="100%"
            color="red"
          >
            {isLoading ? <Preloader /> : 'Yes, Remove'}
          </AppButton>
        </Box>
      </Box>
    </Box>
  </ModalWrapper>
);

export default RemoveCredentialsConfirmModal;
